<template>
  <div className="admin-grid">
    <article class="searchDataTable input-field">
      <v-text-field prepend-icon="search" label="Rechercher" v-model="search" />
    </article>
    <v-dialog
      class="admin-dialog"
      v-model="dialog.open"
      max-width="95%"
      max-height="80%"
    >
      <site-interface
        mode="user"
        :dialog="dialog"
        @close="closeUserDialog()"
        @update="$emit('update')"
        @edit="goToEditMode()"
        @cancel-edit="cancelEditMode()"
      />
    </v-dialog>
    <v-skeleton-loader v-if="!users" type="table" tile class="mx-auto" />
    <v-data-table
      v-else
      :expanded.sync="expanded"
      :headers="getHeaders()"
      :items="users"
      :search="search"
      item-key="email"
      single-expand
    >
      <template
        v-if="currentUserSuperAdmin === true"
        v-slot:item.abilities="{ item }"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="user-abilities-wrapper">
              <template v-if="item.status.type === 'error'">
                <v-icon class="user-abilities-icon"
                  >fa-exclamation-triangle</v-icon
                >
              </template>
              <template v-else>
                <v-icon
                  :class="
                    'user-abilities-icon' +
                      (item.status.authorizations[0] === true ? '' : ' ghost')
                  "
                  >fa-upload</v-icon
                >
                <v-icon
                  :class="
                    'user-abilities-icon' +
                      (item.status.authorizations[1] === true ? '' : ' ghost')
                  "
                  >fa-cogs</v-icon
                >
              </template>
            </div>
          </template>
          <span class="user-abilities-tooltip">
            {{
              item.status.type !== 'error'
                ? item.status.message
                : item.inconsistanceMsg
            }}
          </span>
        </v-tooltip>
      </template>
      <template
        v-if="currentUserSuperAdmin === true"
        v-slot:item.status.startTime="{ item }"
      >
        <v-tooltip v-if="item.status.type === 'none'" bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="user-status-wrapper">
              <div class="user-status-type">
                <v-icon class="user-status-icon">fa-ban</v-icon>
              </div>
            </div>
          </template>
          <div class="user-status-tooltip">
            <p>
              Aucune donnée importée
            </p>
            <hr />
            <br />
            <p>Etat du scénario : {{ item.statutScenario }}</p>
          </div>
        </v-tooltip>
        <v-tooltip
          v-else-if="
            item.status.type === 'hasImport' || item.status.type === 'hasOptim'
          "
          bottom
        >
          <template v-slot:activator="{ on }">
            <div v-on="on" class="user-status-wrapper">
              <div class="user-status-type combined-icons">
                <v-icon class="user-status-icon combined-primary" medium>
                  far fa-file
                </v-icon>
                <v-icon class="user-status-icon combined-secondary" small>
                  {{
                    item.status.type === 'hasImport' ? 'fa-upload' : 'fa-cogs'
                  }}
                </v-icon>
              </div>
            </div>
          </template>
          <div class="user-status-tooltip">
            <p>
              L'utilisateur possède un
              {{
                item.status.type === 'hasImport'
                  ? 'scénario importé mais non optimisé'
                  : 'scénario importé et optimisé'
              }}
            </p>
            <hr />
            <br />
            <p>Etat du scénario : {{ item.statutScenario }}</p>
          </div>
        </v-tooltip>
        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="user-status-wrapper">
              <div class="user-status-type">
                <div class="user-status-time-display">
                  <v-icon class="user-status-icon" medium>
                    {{
                      item.status.type === 'importing'
                        ? 'fa-upload'
                        : item.status.type === 'optimizing'
                        ? 'fa-cogs'
                        : 'fa-exclamation-triangle'
                    }}
                  </v-icon>
                </div>
                <div class="user-status-time-wrapper">
                  <elapsed-time-display
                    v-if="
                      item.status.type === 'importing' ||
                        item.status.type === 'optimizing'
                    "
                    :elapsed-time="getElapsedTime(item.status.startTime)"
                    :warn="item.status.type === 'importing' ? true : false"
                  />
                </div>
              </div>
            </div>
          </template>
          <div class="user-status-tooltip">
            <p>
              {{
                item.status.type === 'error'
                  ? item.inconsistanceMsg
                  : (item.status.type === 'importing'
                      ? 'Importation'
                      : 'Optimisation') +
                    (formatDate(item.status.startTime) !== null
                      ? ' lancée le ' + formatDate(item.status.startTime)
                      : '')
              }}
            </p>
            <hr />
            <br />
            <p>Etat du scénario : {{ item.statutScenario }}</p>
          </div>
        </v-tooltip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="btn-floating scdf-yellow"
              fab
              v-on="on"
              @click="
                expanded[0] && expanded[0].email === item.email
                  ? close()
                  : expand(item)
              "
            >
              <v-icon>{{
                expanded[0] && expanded[0].email === item.email
                  ? 'close'
                  : 'edit'
              }}</v-icon>
            </v-btn>
          </template>
          Editer cet utilisateur
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              class="btn-floating scdf-red"
              v-on="on"
              @click="deleteUser(item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          Supprimer cet utilisateur
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="
                currentUserSuperAdmin === true &&
                  (item.status.type === 'importing' ||
                    item.status.type === 'optimizing')
              "
              fab
              v-on="on"
              class="btn-floating scdf-red"
              @click="resetUser(item)"
            >
              <v-icon>cached</v-icon>
            </v-btn>
          </template>
          Réinitialiser l'action en cours pour cet utilisateur
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="currentUserSuperAdmin === false"
              fab
              v-on="on"
              class="btn-floating scdf-blue"
              @click="openUserDialog(item)"
            >
              <v-icon>home_work</v-icon>
            </v-btn>
          </template>
          Visualiser les sites rattachés à cet utilisateur
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="getHeaders().length">
          <v-card flat>
            <v-card-text>
              <user-form
                title="Editer les informations"
                :user="item"
                :no-flag="currentUserSuperAdmin === true ? false : true"
                @edit="edit"
                @close-expansion="close()"
              />
            </v-card-text>
          </v-card>
        </td>
      </template>
      <template v-slot:pageText="props">
        Lignes {{ props.pageStart }} - {{ props.pageStop }} sur
        {{ itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios';
import UserForm from '@/components/Form/UserForm';
import ElapsedTimeDisplay from './ElapsedTimeDisplay';
import SiteInterface from './SiteInterface';

const dateFormatLocale = 'fr-FR';

const dateFormatOptions = {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};

export default {
  name: 'admin-grid',

  components: {
    UserForm,
    ElapsedTimeDisplay,
    SiteInterface,
  },

  props: {
    currentTime: {
      type: Date,
      default: null,
    },
    users: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      dialog: {
        editing: false,
        open: false,
        user: null,
      },
      expanded: [],
      previousActionState: null,
      snackbar: false,
      timeout: 4000,
      text: null,
      selected: null,
      currentUserId: null,
      currentUserSuperAdmin: false,
      loading: false,
      pagination: {
        sortBy: 'email',
      },
      search: '',
      lastName: null,
      firstName: null,
      email: null,
      adminId: null,
    };
  },

  computed: {
    getElapsedTime() {
      return timestamp => {
        if (timestamp !== null && timestamp !== undefined) {
          return Math.abs(this.currentTime - timestamp);
        }
        return -1;
      };
    },
  },

  created() {
    this.initialize();
  },

  mounted() {
    //this.$store.dispatch('startIntervalTimer', this.initialize)
  },

  methods: {
    toast(message) {
      this.snackbar = true;
      this.text = message;
    },

    initialize() {
      this.loading = true;
      this.currentUserId = this.$store.state.userInfos.id;
      this.currentUserSuperAdmin = this.$store.state.userInfos.isSuperAdmin;
      if (this.user) {
        this.lastName = this.user.lastName;
        this.firstName = this.user.firstName;
        this.email = this.user.email;
        this.adminId = this.user.adminId;
      } else if (this.userCreatorId) {
        if (!this.userCreatorSuperAdmin) {
          this.adminId = this.userCreatorId;
        }
      }
    },

    submit() {
      const user = {
        lastName: this.lastName,
        firstName: this.firstName,
        email: this.email,
        adminId: this.adminId,
      };
      this.$emit(
        this.user ? 'edit' : 'submit',
        user,
        this.user ? this.user.id : null
      );
      this.lastName = null;
      this.firstName = null;
      this.email = null;
    },

    edit(user, id) {
      axios({
        method: 'patch',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_USER_REPOSITORY +
          '/' +
          id,
        headers: {
          'Content-Type': 'application/json',
          user: this.$store.state.userInfos.email,
        },
        data: {
          ...user,
        },
      })
        .then(() => {
          this.$toasted.show('Utilisateur modifié', { type: 'success' });
          this.initialize();
        })
        .catch(error => {
          if (error.response.status === 409) {
            this.$toasted.show('Cette adresse mail est déjà utilisée', {
              type: 'error',
            });
          } else {
            this.$toasted.show("Erreur lors de l'édition", { type: 'error' });
          }
        });
    },

    deleteUser(user) {
      if (confirm('Voulez-vous vraiment supprimer cet utilisateur ?')) {
        axios({
          method: 'delete',
          url:
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_USER_REPOSITORY +
            '/' +
            user.id,
          headers: {
            'Content-Type': 'application/json',
            user: this.$store.state.userInfos.email,
          },
        })
          .then(() => {
            this.$toasted.show('Utilisateur supprimé', { type: 'success' });
            this.initialize();
          })
          .catch(() => {
            this.$toasted.show('Erreur lors de la suppression', {
              type: 'error',
            });
          });
      }
    },

    resetUser(user) {
      if (
        confirm(
          "Voulez-vous vraiment réinitialiser l'action en cours pour cet utilisateur ?"
        )
      ) {
        axios({
          method: 'get',
          url:
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_RESET_ACTION +
            '?idUser=' +
            user.id,
          headers: {
            'Content-Type': 'application/json',
            user: this.$store.state.userInfos.email,
          },
        })
          .then(() => {
            this.initialize();
            this.$toasted.show('Réinitialisation réussie', { type: 'success' });
          })
          .catch(() => {
            this.$toasted.show('Erreur lors de la réinitialisation', {
              type: 'error',
            });
          });
      }
    },

    openUserDialog(user) {
      this.dialog = {
        editing: false,
        user,
        open: true,
      };
    },

    closeUserDialog() {
      this.dialog = {
        editing: false,
        user: null,
        open: false,
      };
    },

    goToEditMode() {
      this.dialog = {
        editing: true,
        user: this.dialog.user,
        open: this.dialog.open,
      };
    },

    cancelEditMode() {
      this.dialog = {
        editing: false,
        user: this.dialog.user,
        open: this.dialog.open,
      };
    },

    formatDate(timestamp) {
      timestamp = new Date(timestamp);
      if (timestamp !== null && timestamp !== undefined) {
        return timestamp.toLocaleDateString(
          dateFormatLocale,
          dateFormatOptions
        );
      }
      return null;
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    getHeaders() {
      if (this.currentUserSuperAdmin === true) {
        return [
          {
            text: 'E-mail',
            value: 'email',
            align: 'left',
          },
          {
            text: 'Nom',
            value: 'lastName',
            align: 'left',
          },
          {
            text: 'Prénom',
            value: 'firstName',
            align: 'left',
          },
          {
            text: 'Coopérative',
            value: 'cooperative',
            align: 'left',
          },
          {
            text: 'Habilitations',
            value: 'abilities',
            align: 'center',
          },
          {
            text: 'Statut',
            value: 'status.startTime',
            align: 'center',
          },
          {
            text: 'Actions',
            value: 'actions',
            align: 'center',
          },
        ];
      } else {
        return [
          {
            text: 'E-mail',
            value: 'email',
            align: 'left',
          },
          {
            text: 'Nom',
            value: 'lastName',
            align: 'left',
          },
          {
            text: 'Prénom',
            value: 'firstName',
            align: 'left',
          },
          {
            text: 'Nb. sites',
            value: 'sites.length',
            align: 'center',
          },
          {
            text: 'Actions',
            value: 'actions',
            align: 'center',
          },
        ];
      }
    },

    expand(item) {
      this.close();
      if (item.status.type === 'error') {
        this.$toasted.show('Edition impossible car erreur.', { type: 'error' });
      } else if (
        item.status.type === 'importing' ||
        item.status.type === 'optimizing'
      ) {
        const message =
          this.currentUserSuperAdmin === true
            ? 'Edition impossible car action en cours.'
            : 'Cet utilisateur ne peut actuellement pas être modifié. Veuillez réessayer plus tard.';
        this.$toasted.show(message, { type: 'error' });
      } else {
        this.expanded.push(item);
      }
    },
    close() {
      this.expanded = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.user-status-wrapper {
  cursor: default;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  .user-status-type {
    .user-status-icon {
      cursor: default;
      display: block;
      font-size: 32px !important;
      line-height: 32px;
    }

    &.combined-icons {
      display: block;
      height: 32px;
      margin: 0 auto;
      padding-left: 4px;
      position: relative;
      width: 32px;

      .user-status-icon {
        cursor: default;
        display: block;
        position: absolute;
        &.combined-primary {
          font-size: 32px !important;
          position: absolute;
        }
        &.combined-secondary {
          font-size: 16px !important;
          top: 12px;
          left: 12px;
          &::before {
            background: white;
            border-radius: 3px;
            padding: 2px;
          }
        }
      }
    }
  }
  .user-status-time-display {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .user-status-time-wrapper {
      cursor: default;
    }
  }
}

.user-abilities-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .user-abilities-icon {
    display: block;
    font-size: 32px;
    line-height: 32px;
    padding: 0 5px;

    &.ghost {
      opacity: 0.25;
    }
  }
}

.user-status-tooltip,
.user-abilities-tooltip {
  font-size: 16px;
}

.btn-floating {
  margin: 5px;
}

.admin-dialog {
  height: 80%;
}
</style>
